import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Unstable_Grid2";
import { formatCurrency } from "tools/stringUtils";
import { useMediaQuery, useTheme } from "@mui/material";
import PriceRow from "./PriceRow";

interface CartOverviewPriceSummaryProps {
  total: number;
  totalProduct: number;
  totalAdjustment: number;
  totalShipping: number;
}

const CartOverviewPriceSummary: FC<CartOverviewPriceSummaryProps> = ({
  total,
  totalProduct,
  totalAdjustment,
  totalShipping,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const breakpointDownXs = useMediaQuery(theme.breakpoints.down("sm"));
  const fontSize = breakpointDownXs ? 16 : 18;

  return (
    <Grid container spacing={0.5} pt={2} pb={2}>
      <PriceRow
        fontSize={fontSize}
        label={t("cart.articleTotal")}
        value={formatCurrency(totalProduct)}
      />

      {totalAdjustment !== 0 && (
        <PriceRow
          fontSize={fontSize}
          label={t("cart.promotionCode")}
          value={formatCurrency(totalAdjustment)}
        />
      )}

      <PriceRow
        fontSize={fontSize}
        label={t("cart.shippingCosts")}
        value={formatCurrency(totalShipping)}
      />

      <PriceRow
        bold
        fontSize={fontSize}
        label={t("cart.total")}
        value={formatCurrency(total)}
      />
    </Grid>
  );
};

export default React.memo(CartOverviewPriceSummary);
